import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import NarrowInputField from "../../components/input/new/narrowInputField";
import NarrowPasswordField from "../../components/input/new/narrowPasswordField";
import { FcGoogle } from "react-icons/fc";
import { FaApple } from "react-icons/fa";
import { supabase } from "../../supabaseClient";
import "./clientSignup.css";
import ClientOnboardingHeader from "../../components/clientToolbar/clientOnboardingHeader";
import Footer from "../../components/footer";
import BackIcon from "../assets/backIcon.png";
import ClientLoginPopup from "../../home/new/components/clientLoginPopup";

const ClientSignup = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const openLoginPopup = () => setShowLoginPopup(true);
  const closeLoginPopup = () => setShowLoginPopup(false);

  const passwordsMatch = password === confirmPassword;

  const handleContinue = async () => {
    if (password.length < 8 || !passwordsMatch) return;
    try {
      const { user, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          emailRedirectTo: "https://www.quidpro.ai/complete-signup/",
          data: { role: "client" },
        },
      });
      if (error) {
        console.error("Error signing up:", error.message);
        alert("Failed to send verification email.");
      } else {
        console.log("No error—about to navigate");
        navigate("/createuser/confirm-email");
      }
    } catch (err) {
      console.error("Unexpected error:", err);
      alert("Something went wrong. Please try again later.");
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className="client-signup-page-container">
        <ClientOnboardingHeader openLoginPopup={openLoginPopup} />
        <div>
          <div className="header-div">
            <img
              src={BackIcon}
              onClick={() => navigate(-1)}
              style={{ width: "24px", height: "24px" }}
              alt="back icon"
            />
            <h1 className="client-signup-header-title">Create an account</h1>
          </div>

          <NarrowInputField
            name="Email Address"
            title="Email address"
            placeholder="Enter your email"
            isRequired
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            halfWidth={false}
          />

          <NarrowPasswordField
            title="Password"
            placeholder="Enter your password"
            isRequired
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <NarrowPasswordField
            title="Confirm Password"
            placeholder="Re-enter your password"
            isRequired
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <ul className="password-requirements">
            <li>Use at least 8 characters</li>
            <li>Use letters</li>
            <li>Use numbers</li>
            <li>Use special characters, like !#$%?</li>
          </ul>

          <button
            className="client-signup-continue-button"
            onClick={handleContinue}
            disabled={password.length < 8 || !passwordsMatch}
          >
            Continue
          </button>

          <div className="divider">
            <span>or</span>
          </div>
          <hr className="h-rule-popup" />

          <div className="signup-social-login-buttons">
            <button className="signup-google-btn">
              <FcGoogle style={{ paddingBottom: "1px" }} />
              Continue with Google
            </button>
            <button className="signup-apple-btn">
              <FaApple style={{ paddingBottom: "3px" }} />
              Continue with Apple
            </button>
          </div>

          <div className="signup-create-account">
            <span className="signup-login-cta">
              Already have an account?{" "}
              <a className="signup-login-cta-href" href="/">
                Log in
              </a>
            </span>
          </div>
        </div>
      </div>

      {showLoginPopup && (
        <ClientLoginPopup show={showLoginPopup} onClose={closeLoginPopup} />
      )}
      <Footer />
    </div>
  );
};

export default ClientSignup;
